import { css } from 'styled-components';
import { ReadTimeShape } from '../../../../../components/RelatedContent/ReadTimeShape/style';
import {
  Body,
  cardBorderPx,
  ContentWrapper,
  Heading,
  ImageWrapper,
  ReadTime,
  ReadTimeWrapper,
  RelatedContentCardContainer,
  RelatedContentCardContainerProps,
} from '../../../../../components/RelatedContent/RelatedContentCard/styles';
import spacing, { spacingWithBorder } from '../../../../../helpers/spacing';
import { colors, themeSpecificColors } from '../../../colors';
import { fonts } from '../../../fonts';
import { interactionStatesForCards } from '../../../helpers/commonStyles';

const nonDisabledLinkStyles = css`
  ${interactionStatesForCards};
  ${Heading} {
    color: ${colors.neutral01};
  }

  &:hover {
    ${Heading} {
      text-decoration-line: underline;
      color: ${colors.core01};
    }
  }

  &:focus {
    ${Heading} {
      color: inherit;
    }
  }

  &:active {
    ${Heading} {
      color: inherit;
      text-decoration-line: none;
    }
  }
`;

const disabledLinkStyles = css`
  border-color: ${colors.cardBorder};
`;

export default css<RelatedContentCardContainerProps>`
  ${RelatedContentCardContainer}, &${RelatedContentCardContainer}  {
    box-sizing: content-box;
    ${({ disabled }) => !disabled && nonDisabledLinkStyles};
    ${({ disabled }) => disabled && disabledLinkStyles};
  }

  ${ImageWrapper} {
    border-radius: 0;

    height: 216px;
  }

  ${ContentWrapper} {
    text-align: left;
  }

  ${Heading} {
    text-align: left;
    font-weight: 700;
  }

  ${Body} {
    ${fonts.paragraphSmall};
    margin: ${spacing(1)} 0 0;
  }

  ${ReadTimeWrapper} {
    justify-content: flex-start;
    padding-top: 0;
    padding-right:${spacingWithBorder(3, cardBorderPx)};
    padding-bottom: ${spacingWithBorder(3, cardBorderPx)};
    padding-left: ${spacingWithBorder(3, cardBorderPx)};
  }

  ${ReadTimeShape} {
    background-color: transparent;
    padding: 0;
    display: flex;
    align-items: center;

    ::before {
      box-shadow: none;
    }

    ::after {
      box-shadow: none;
    }
  }

  ${ReadTime} {
    letter-spacing: normal;
    font-size: 1rem;
    line-height: 2rem;
    color: ${themeSpecificColors.neutral03_darker};
  }
`;
